export default "__VITE_ASSET__DLKfnvnb__"